$(document).ready(function () {
    
    /****** Desktop Menu ******/
    var DESKTOP_MENU = {
        EXPANDED_CLASS: "expanded bg-primary-100",
        currentExpandedMenu: undefined
    };

    DESKTOP_MENU.collapse = function (menuName) {
        console.log('[MEGAMENU] Collapsing ' + menuName);
        $currentMenu = $('[data-mega-menu=' + menuName + ']');
        $currentMenu.removeClass('visible');

        $currentLink = $('[data-toggle-mega-menu=' + menuName + ']');
        $currentLink.removeClass(DESKTOP_MENU.EXPANDED_CLASS);
        DESKTOP_MENU.currentExpandedMenu = undefined;

        $('#MainContent').css('margin-top', 0);
    }

    $('[data-toggle-mega-menu]').click(function () {
        var $link = $(this);
        var newMenuName = $link.attr('data-toggle-mega-menu');
        var $newMenu = $('[data-mega-menu=' + newMenuName + ']');

        if (newMenuName === DESKTOP_MENU.currentExpandedMenu) {
            DESKTOP_MENU.collapse(newMenuName);
        } else {
            if (DESKTOP_MENU.currentExpandedMenu) {
                DESKTOP_MENU.collapse(DESKTOP_MENU.currentExpandedMenu);
            }

            console.log('[MEGAMENU] Expanding ' + newMenuName);
            $newMenu.addClass('visible');
            $link.addClass(DESKTOP_MENU.EXPANDED_CLASS);
            $('#MainContent').css('margin-top', $newMenu.height());
            DESKTOP_MENU.currentExpandedMenu = newMenuName;
        }
    })

    /****** Mobile Menu ******/
    $('[data-toggle-mobile-menu]').click(function () {
        $('[data-mobile-menu]').addClass('visible');
        $('body').addClass('overflow-hidden');
    })

    $('[data-mobile-menu-close-button]').click(function () {
        $('[data-mobile-menu]').removeClass('visible');
        $('body').removeClass('overflow-hidden');
    })

    $('[data-open-child-menu]').click(function () {
        var childName = $(this).attr('data-open-child-menu');
        $('[data-mobile-menu-hub]').addClass('show-child');
        $('[data-mobile-menu-child=' + childName + ']').addClass('visible');
    })

    $('[data-close-child-menu]').click(function () {
        var childName = $(this).attr('data-close-child-menu');
        $('[data-mobile-menu-hub]').removeClass('show-child');
        $('[data-mobile-menu-child=' + childName + ']').removeClass('visible');
    })

    /****** Customer login page ('templates/customers/login.liquid') ******/
    var LOGIN_PAGE = {
        recoverPasswordForm: $('[recover-password-form]'),
        customerLoginForm: $('[customer-login-form]'),
        forgotPasswordFormToggle: $('[forgot-password-toggle]'),
        recoverPasswordSuccessFlag: $('[recover-password-success-flag]')[0],
        recoverPasswordSuccessMsg: $('[recover-password-success-msg]')
    };

    LOGIN_PAGE.checkUrlHash = function () {
        if (window.location.hash === '#recover') {
            LOGIN_PAGE.toggleRecoverPasswordForm();
        }
    }

    LOGIN_PAGE.checkRecoverPasswordSuccess = function () {
        if (LOGIN_PAGE.recoverPasswordSuccessFlag) {
            LOGIN_PAGE.recoverPasswordSuccessMsg.show();
        }
    }

    LOGIN_PAGE.toggleRecoverPasswordForm = function () {
        console.log('> Toggle recover password form');
        LOGIN_PAGE.recoverPasswordForm.toggleClass('hidden');
        LOGIN_PAGE.customerLoginForm.toggleClass('hidden');
    }

    LOGIN_PAGE.forgotPasswordFormToggle.click(function () {
        console.log('> Forgot password link was clicked');
        LOGIN_PAGE.toggleRecoverPasswordForm();
    })

    LOGIN_PAGE.checkUrlHash();
    LOGIN_PAGE.checkRecoverPasswordSuccess();
})